import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Spinner from 'shared/components/Spinner';
import { DEVELOPMENT_MODE, OAUTH } from 'shared/constants';
import { userportal } from 'shared/routes';
import Page from 'userportal/components/Page';
import { actions, selectors } from 'userportal/ducks/auth';
import apiClient from 'userportal/lib/ApiClient';

const Callback = () => {
  const { t } = useTranslation('userportal');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const loggedIn = useSelector(selectors.isLoggedIn);

  const fetchData = async () => {
    const csrfState = localStorage.getItem(OAUTH.LINKEDIN.STATE_KEY);
    const qs = queryString.parse(window.location.search) || {};

    if (csrfState !== qs.state || qs.error) {
      setError(qs.error || 'Invalid CSRF state');
      return;
    }

    try {
      const auth = await apiClient.post('/oauth/linkedin', { code: qs.code });
      if (!(auth && auth.token)) {
        throw new Error('Invalid auth response');
      }
      dispatch(actions.loginSucceeded(auth));
    } catch (err) {
      setError(err.error);
    }
  };

  useEffect(() => {
    if (!loggedIn) {
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (loggedIn) {
      navigate(userportal.root, { replace: true });
    }
  }, [loggedIn]);

  return (
    <Page relative={false}>
      {!error && (
        <Spinner splash>{t('page.oauth.inProgress')}</Spinner>
      )}
      {error && (
        <div className="col-12 text-center">
          <h3 className="page_title">{t('page.oauth.errorTitle')}</h3>
          <p>
            {DEVELOPMENT_MODE ? error : t('page.oauth.errorText')}
          </p>
        </div>
      )}
    </Page>
  );
};

export default Callback;
